/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
'use strict';

import { AppContext, FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import FliwasPermissionWebApi from '../webapi/FliwasPermissionWebApi';
import { ActionTypes, ClassNames } from '../constants/Constants';

const className = ClassNames.FliwasPermission;

export default {

    selectedNamespace: (namespace) => AppContext.getDispatcher().dispatch({
        type: ActionTypes.SELECTED_FLIWAS_PERMISSION_NAMESPACE,
        payload: {
            ...namespace
        }
    }),
    getPermissionStatesByRoleId: (name, query) => RemoteDataActions.list(name, className, query, FliwasPermissionWebApi.getPermissionStatesByRoleId),
    getPermissionState: (name, query) => RemoteDataActions.item(name, className, query, FliwasPermissionWebApi.getPermissionState),

    listAllNamespaces: (name, query) => RemoteDataActions.list(name, className, query, FliwasPermissionWebApi.listAllNamespaces),
    getUserRoles: (name, query) => RemoteDataActions.item(name, className, query, FliwasPermissionWebApi.getUserRoles),

    setPermission: (item, formId, closeForm) => FormActions.submitForm(FliwasPermissionWebApi.setFiliwasPermissions, item, formId, closeForm)
};



// WEBPACK FOOTER //
// ./js/actions/FliwasPermissionActions.js